module.exports = __webpack_public_path__ + "static/media/trott.9867d5f7.mp3";